import classNames from 'classnames';
import React, { HTMLAttributes } from 'react';
import { Scrollbars } from '@meitu/saas-ui';
import ToolTip from '@meitu/saas-ui/es/tooltip';
import { ListType } from '@/services/size-list/index.d';
import { TITLE_SIZE_ID } from '../../utils';
import Title from '../title';
import './index.less';
import IconFont from '@meitu/xdesign-icon-font';

export interface IListProps extends HTMLAttributes<HTMLDivElement> {
    sizeList: ListType[];
    onSelectSize?: (item: ListType) => void;
    currentWidth: number;
    currentHeight: number;
}

const List: React.FC<IListProps> = (props) => {
    const { sizeList, onSelectSize, currentWidth, currentHeight } = props;

    return (
        <Scrollbars className="adjust-size-list__scroll" style={{ width: '100%', height: 'calc( 100% - 22px)' }}>
            <div className="adjust-size-list">
                {sizeList.map((item, index) => {
                    //title 直接return
                    if (item.id === TITLE_SIZE_ID) {
                        return (
                            <Title
                                key={index}
                                className="adjust-size-modal"
                                scrollClassName="adjust-size-list__scroll"
                                item={item}
                                currentWidth={currentWidth}
                                currentHeight={currentHeight}
                            />
                        );
                    }
                    return (
                        <div
                            key={index}
                            className={classNames('adjust-size-list__item')}
                            onClick={() => {
                                onSelectSize?.(item);
                            }}
                        >
                            <div
                                className={classNames('adjust-size-list__item-content', {
                                    'size-check': item.isCheck,
                                })}
                            >
                                <div className={classNames('adjust-size-list__item-name')}>
                                    <ToolTip title={item.default_name}>
                                        <label>{item.default_name}</label>
                                    </ToolTip>
                                </div>
                                {item.width && item.height ? <span>{`${item.width} × ${item.height} px`}</span> : null}
                            </div>
                            {item.isCheck ? (
                                <div className={classNames('adjust-size-list__item-check')}>
                                    <IconFont name="CheckBlack" fontSize={14} color="var(--content-system-link)" />
                                </div>
                            ) : null}
                        </div>
                    );
                })}
            </div>
        </Scrollbars>
    );
};
export default React.memo(List);
